import { Component, DestroyRef, inject, Input, OnInit, ViewChild } from '@angular/core';

import { FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faPlusCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { NbToastrService } from '@nebular/theme';
import { AuthService } from '../../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { FarmDTO } from '../../../../../harvest-engine/core/models/farm';
import { UserDTO } from '../../../../../harvest-engine/core/models/user';
import { FieldTaskDTO } from '../../../../../harvest-engine/modules/field-events/models/field-task';
import { BlockSelectComponent } from '../../general/block-select/block-select.component';
import { UserSelectComponent } from '../../general/user-select/user-select.component';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FarmsService } from '../../../../../harvest-engine/core/services/farms.service';
import { FieldEventType } from '../../../../../harvest-engine/modules/field-events/models/field-event-type';
import { FieldEventTypesService } from '../../../../../harvest-engine/modules/field-events/services/field-event-types.service';
import { FieldTasksService } from '../../../../../harvest-engine/modules/field-events/services/field-tasks.service';

@Component({
  selector: 'm-field-task-input',
  templateUrl: './field-task-input.component.html',
  styleUrls: ['./field-task-input.component.scss']
})
export class FieldTaskInputComponent implements OnInit {

  constructor(
    private fieldEventTypesService: FieldEventTypesService,
    private fieldTasksService: FieldTasksService,
    private authService: AuthService,
    private farmService: FarmsService,
    private dialog: MatDialog,
    private toastr: NbToastrService,
    private errorService: ErrorService,
    private router: Router

  ) { }

  public faTimesCircle = faTimesCircle;
  public faPlusCircle = faPlusCircle;

  public farmsLoaded: boolean = false;
  public fieldTaskLoaded: boolean = false;
  public fieldEventTypesLoaded: boolean = false;
  public saveAttempted: boolean = false;

  private destroyRef = inject(DestroyRef);

  @ViewChild('fieldTaskForm', { static: false }) private form: NgForm;

  fieldEventTypesSelect: FieldEventType[];
  @Input() fieldTask: FieldTaskDTO = {};
  farmList: FarmDTO[];
  // form = new FormGroup({
  //   dueDate: new FormControl('dueDate', [Validators.required]),
  //   fieldEventType: new FormControl('fieldEventType', [Validators.required]),
  //   comment: new FormControl(),
  //   startDate: new FormControl()
  // });
  isSaving: boolean = false;
  selectedUsersList: UserDTO[] = [];

  ngOnInit() {

    this.getFieldEventTypes();
    this.getFarms();
    this.fieldTask.requestedBlocks = [];
    this.getFieldTask();

  }
  
  onSubmit(formDirective: FormGroupDirective) {
    this.saveAttempted = true;

    if (!this.form.valid) {
      this.toastr.danger('Please review inputs', 'Failed to save!');
    }

    if (this.form.valid) {

      this.isSaving = true;
  
      if(this.fieldTask.assignedUsers !== undefined){
        this.fieldTask.assignedUsers.length = 0;
      }
     

      this.fieldTask.assignedUsers = [];
      for (const u of this.selectedUsersList) {
        this.fieldTask.assignedUsers.push(u);
      };

      // let missing = this.fieldTask.assignedUsers.filter(item => this.selectedUsersList.indexOf(item) < 0);
      //   

      this.fieldTask.isActive = true;

      if (this.fieldTask.fieldTaskId == 0 || this.fieldTask.fieldTaskId == null) {
        this.fieldTasksService.apiFieldTasksPost(this.fieldTask).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:result => {

            if (result.fieldTaskId !== 0) {
              this.toastr.success('Success!', 'Field task added.');

              this.fieldTask.requestedBlocks = [];
              this.fieldTask.assignedUsers = [];
              this.isSaving = false;
              this.selectedUsersList = [];
              this.form.reset();
              formDirective.resetForm();
              this.saveAttempted = false;
       
            }

          }, error:err => {
            this.errorService.handleError(err);
          }});
      } else {
        this.fieldTasksService.apiFieldTasksByIdPut(
          this.fieldTask.fieldTaskId, this.fieldTask).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:result => {

            if (result.fieldTaskId !== 0) {
              this.toastr.success('Success!', 'Field task added.');

              this.isSaving = false;
              this.saveAttempted = false;
              this.router.navigateByUrl('/field-tasks/ft-report');
            }

          }, error:err => {
            this.errorService.handleError(err);
      }});
      }
    }

  }

  getFieldEventTypes(): void {
    this.fieldEventTypesService.apiFieldEventTypesGet().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:fieldEventTypes => {
      this.fieldEventTypesSelect = fieldEventTypes;
      this.fieldEventTypesLoaded = true;
    }, error:err => this.errorService.handleError(err)});
  }

  getFarms(): void {
    this.farmService.apiFarmsGet().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(farms => {
      this.farmList = farms;
      this.farmsLoaded = true;

    });
  }

  getFieldTask(): void {
    if(this.fieldTask.fieldTaskTypeId !== undefined){ 
    this.fieldTasksService.apiFieldTasksByIdGet(this.fieldTask.fieldTaskId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(task => {
      this.fieldTask = task;
      this.fieldTaskLoaded = true;
    });
      this.selectedUsersList = this.fieldTask.assignedUsers;
  }
}

  openBlockSelectDialog(): void {
    const dialogRef = this.dialog.open(BlockSelectComponent, {
      width: '50%',
      height: '85%',
      data: { farmList: this.farmList, selectedBlocks: this.fieldTask.requestedBlocks },
      autoFocus: false
    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (this.fieldTask.requestedBlocks === undefined) {
        this.fieldTask.requestedBlocks = [];
      }
      if (result !== undefined) {
        this.fieldTask.requestedBlocks = result.selectedBlocks;
      }
    });
  }


  openUserSelectDialog(): void {
    const dialogRef = this.dialog.open(UserSelectComponent, {
      width: '40%',
      data: { selectedUserList: this.selectedUsersList }

    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (result !== undefined) {
        this.selectedUsersList = result.selectedUserList;
      }
    });
  }

}
